/**
 * Maps beer duplicate review payloads to BeerCard `beer` shape.
 */

function resolveStyleDisplay(styleValue, styleMap) {
  if (!styleValue) {
    return '';
  }
  const styleKey = String(styleValue);
  if (styleMap?.[styleKey]) {
    return styleMap[styleKey];
  }
  return styleKey;
}

export function mapMatchedBeerToCardBeer(reviewRow, styleMap) {
  const matched = reviewRow?.matchedBeer || {};
  const styleLabel = resolveStyleDisplay(matched.style, styleMap);
  return {
    id: matched.id || `matched-${reviewRow?.id || 'unknown'}`,
    name: matched.name || 'Unnamed beer',
    breweryId: reviewRow?.breweryId,
    breweryName: reviewRow?.breweryName,
    abv: matched.abv,
    style: matched.style,
    styleName: styleLabel,
    description: matched.description,
    ratings: {},
  };
}

export function mapIncomingBeerToCardBeer(reviewRow, styleMap) {
  const incoming = reviewRow?.newBeer || {};
  const styleLabel = resolveStyleDisplay(incoming.style, styleMap);
  return {
    id: `incoming-${reviewRow?.id || 'unknown'}`,
    name: incoming.name || 'Unnamed beer',
    breweryId: incoming.breweryId || reviewRow?.breweryId,
    breweryName: reviewRow?.breweryName,
    abv: incoming.abv,
    style: incoming.style,
    styleName: styleLabel,
    description: incoming.description,
    ratings: {},
  };
}

export function mergeReviewRowWithMatchedBeer(reviewRow, matchedBeer) {
  if (!reviewRow || !matchedBeer) {
    return reviewRow;
  }
  return {
    ...reviewRow,
    matchedBeer: {
      ...(reviewRow.matchedBeer || {}),
      ...matchedBeer,
    },
  };
}
